import React, { useLayoutEffect, useState } from 'react';
import { roleModules } from '@restore/roleModules/roleModules';
import { RoleModuleConfig } from '@restore/roleModules/types';
import { UserRoles } from '@dynamika-shared/types/auth';
import { useAuthSlice } from '@restore/auth/auth.slice';
import {
  cancelSagas,
  injectSagas,
  injectSlices,
  removeReducers,
} from '@restore/store';

export const WithRoleModules: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const user = useAuthSlice(state => state.data);
  const role = user?.selectedRole as UserRoles | undefined;
  const [isReady, setIsReady] = useState(false);

  useLayoutEffect(() => {
    setIsReady(false);

    if (!role || !(Object.values(UserRoles) as string[]).includes(role)) return;

    const modules: RoleModuleConfig | undefined = roleModules[role];
    if (!modules) return;

    if (modules.slices) {
      injectSlices(modules.slices);
    }

    if (modules.sagas) {
      injectSagas(modules.sagas);
    }

    setTimeout(() => setIsReady(true), 0);

    return () => {
      if (modules.slices) {
        removeReducers(modules.slices.map(slice => slice.name));
      }
      if (modules.sagas) {
        cancelSagas(Object.keys(modules.sagas));
      }
      setIsReady(false);
    };
  }, [role]);

  if (!isReady) {
    return null;
  }

  return <>{children}</>;
};
